module.exports = __webpack_public_path__ + "static/pakmaya-sm-37aa857e449fa972c947c271c78730c0.jpg";